<script>

export default {
    props: {
        news: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            // cardScheme: {
            //     'Press Release': '-blue',
            //     'Portfolio News': '-dark-sky-blue',
            //     'Portfolio Press Release': '-cloud-blue',
            // },
            cardScheme: ['-blue', '-dark-sky-blue', '-cloud-blue'],
        }
    },
}
</script>
<template>
    <article class="color-card" :class="cardScheme[Math.floor(Math.random() * cardScheme.length)]">
        <h2 class="color-card__heading">
            <a :href="news.link" v-text="news.title" class="bare-link"></a>
        </h2>
        <h3 class="color-card__eyebrow" v-text="news.category.title"></h3>
        <time class="color-card__date" v-text="news.date"></time>
    </article>
</template>
